'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _functions = require('../helpers/functions');

var _blocks = require('../helpers/blocks');

var _types = require('../types');

exports.default = function firstPass(compiler, programPath) {
  return programPath.traverse({
    Method(path) {
      var node = path.node;

      if ((0, _functions.isNamedArrowFunction)(node)) {
        node.body = (0, _blocks.toBlockStatement)(node.body);
        path.replaceWith(node);
      }
    }, MemberExpression(path) {
      if (path.node.optional && (0, _types.isa)(path.parent, "ArrowFunctionExpression")) {
        (0, _functions.ensureBlockArrowFunctionExpression)(path.parentPath);
      }
    } });
}; // Perform non-semantic AST transformations like ensuring function bodies
// are blocks, etc.


module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@oigroup/babel-plugin-lightscript/lib/visitors/firstPass.js
// module id = 999
// module chunks = 0